<template>
  <div class="referral-tier">
    <v-row no-gutters class="hidden-sm-and-down">
      <v-col cols="2" sm="3" lg="2">
        <label>{{ stringFormat($t(`label.totalTierMember`), 1) }}</label>
        <v-card class="primary yellow--text title text-center pa-1 mt-3">
          <v-icon class="yellow--text">person</v-icon>
          : {{ referralOverview.downline_lv1 }}
        </v-card>
        <v-card class="detail-card base mt-3 pt-2 px-1">
          <v-card-title class="title">{{ stringFormat($t(`label.tier`), 1) }}</v-card-title>
          <v-divider class="mx-3 primary"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <label class="detail">{{ stringFormat($t(`label.downlinesCommission`), getConfig(1)) }}</label>
              </v-col>
              <!-- <v-col cols=12>
                                <label class="detail">{{stringFormat($t(`label.downlinesCommission`), "0.7")}}</label>
                            </v-col>
                            <v-col cols=12>
                                <label class="detail">{{stringFormat($t(`label.levelCommission`), "0.7%")}}</label>
                            </v-col> -->
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="1"></v-col>
      <v-col cols="2" sm="3" lg="2">
        <label>{{ stringFormat($t(`label.totalTierMember`), 2) }}</label>
        <v-card class="primary yellow--text title text-center pa-1 mt-3">
          <v-icon class="yellow--text">person</v-icon>
          : {{ referralOverview.downline_lv2 }}
        </v-card>
        <v-card class="detail-card base mt-3 pt-2 px-1">
          <v-card-title class="title">{{ stringFormat($t(`label.tier`), 2) }}</v-card-title>
          <v-divider class="mx-3 primary"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <label class="detail">{{ stringFormat($t(`label.downlinesCommission`), getConfig(2)) }}</label>
              </v-col>
              <!-- <v-col cols=12>
                                <label class="detail">{{stringFormat($t(`label.levelCommission`), "0.2%")}}</label>
                            </v-col> -->
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="1"></v-col>
      <v-col cols="2" sm="3" lg="2">
        <label>{{ stringFormat($t(`label.totalTierMember`), 3) }}</label>
        <v-card class="primary yellow--text title text-center pa-1 mt-3">
          <v-icon class="yellow--text">person</v-icon>
          : {{ referralOverview.downline_lv3 }}
        </v-card>
        <v-card class="detail-card base mt-3 pt-2 px-1">
          <v-card-title class="title">{{ stringFormat($t(`label.tier`), 3) }}</v-card-title>
          <v-divider class="mx-3 primary"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <label class="detail">{{ stringFormat($t(`label.downlinesCommission`), getConfig(3)) }}</label>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="hidden-md-and-up">
      <v-col cols="12">
        <p>{{ $t('info.mobile_referal_tier') }}</p>
        <v-row v-if="!isLoggedIn" class="prelogin-panel">
          <v-col cols="12">
            <span>{{ $t('info.mobile_referal_beforeLogin') }}</span>
          </v-col>
          <v-col class="inpage-before-login-first text-center beforeLoginBtn" @click="goToRegisterPage()">
            <b>{{ $t(`label.register`) }}</b>
          </v-col>
          <v-col class="inpage-navigator-before-login-second text-center beforeLoginBtn" @click="goToLoginPage()">
            <b>{{ $t(`label.login`) }}</b>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" class="text-left">
            <span>{{ $t(`label.mobileReferalCode`) }}</span>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col md="6" sm="8">
                <v-card class="referralCode-card text-center">
                  <v-card-text>{{ referralCode }}</v-card-text>
                  <span></span>
                </v-card>
              </v-col>
              <v-col>
                <v-card class="fill-height share-card" @click="share()">
                  <!--              <v-btn height="100%" width="100%" class="sharenow-btn">Share now</v-btn>-->
                  <span style="font-size: 1.3rem;">SHARE</span>
                  <div class="game-menu-image" :style="`--src: url('/static/svg/share.svg')`">
                    <img :url="`/static/svg/share.svg`" class="side-menu-icon" />
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!--      <v-col>-->
      <!--        <v-row> Your Referral Code:</v-row>-->
      <!--        <v-row></v-row>-->
      <!--      </v-col>-->
    </v-row>
    <v-row class="hidden-md-and-up">
      <v-col class="timeline-container col">
        <v-timeline dense>
          <v-timeline-item fill-dot color="grey lighten-2" class="active-tier">
            <template v-slot:icon>
              <img style="width:22px;" :src="`/static/svg/tier-icon.svg`" />
            </template>

            <v-row style="align-items: center">
              <v-col :cols="isLoggedIn ? '8' : '12'">
                <v-card class="tier-card text-center active-tier">
                  <v-card-text>{{ isLoggedIn ? memberInfo.memberCode : `You` }}</v-card-text>
                </v-card>
              </v-col>
              <v-col v-if="isLoggedIn" style="padding: unset">
                <v-card class="tier-card text-center active-tier">
                  <v-card-text>{{ totalDownlineCount }}</v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item v-for="(item, i) in tierList" :key="i" fill-dot color="grey lighten-2">
            <template v-slot:icon>
              <img style="width:22px;" :src="`/static/svg/tier-icon.svg`" />
            </template>
            <v-row style="align-items: center">
              <v-col :cols="isLoggedIn ? '8' : '12'">
                <v-card class="tier-card text-center" color="grey lighten-2">
                  <v-card-text>{{ item.title }} ( {{getConfig(i+1)}}%)</v-card-text>
                </v-card>
              </v-col>
              <v-col v-if="isLoggedIn" style="padding: unset">
                <v-card>
                  <v-card-text class="tier-card text-center">{{ item.downlineCount }}</v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
    <!--        <v-carousel class="mobile-carousel" v-model="currentMobileSlide" hide-delimiters v-else>-->
    <!--            <v-carousel-item>-->
    <!--                <v-sheet tile light>-->
    <!--                    <v-row no-gutters justify="center">-->
    <!--                        <v-col cols=8 sm=7>-->
    <!--                            <label>{{stringFormat($t(`label.totalTierMember`), 1)}}</label>-->
    <!--                            <v-card class="primary yellow&#45;&#45;text title text-center pa-1 mt-3"><v-icon class="yellow&#45;&#45;text">person</v-icon> : {{referralOverview.downline_lv1}}</v-card>-->
    <!--                            <v-card class="detail-card base mt-3 pt-2 px-1">-->
    <!--                                <v-card-title class="title">{{stringFormat($t(`label.tier`), 1)}}</v-card-title>-->
    <!--                                <v-divider class="mx-3 primary"></v-divider>-->
    <!--                                <v-card-text>-->
    <!--                                    <v-row>-->
    <!--                                        <v-col cols=12>-->
    <!--                                           <label class="detail">{{stringFormat($t(`label.downlinesCommission`), getConfig(1))}}</label>-->
    <!--                                        </v-col>-->
    <!--                                    </v-row>-->
    <!--                                </v-card-text>-->
    <!--                            </v-card>-->
    <!--                        </v-col>-->
    <!--                    </v-row>-->
    <!--                </v-sheet>-->
    <!--            </v-carousel-item>-->
    <!--            <v-carousel-item>-->
    <!--                <v-sheet tile light>-->
    <!--                    <v-row no-gutters justify="center">-->
    <!--                        <v-col cols=8 sm=7>-->
    <!--                            <label>{{stringFormat($t(`label.totalTierMember`), 2)}}</label>-->
    <!--                            <v-card class="primary yellow&#45;&#45;text title text-center pa-1 mt-3"><v-icon class="yellow&#45;&#45;text">person</v-icon> : {{referralOverview.downline_lv2}}</v-card>-->
    <!--                            <v-card class="detail-card base mt-3 pt-2 px-1">-->
    <!--                                <v-card-title class="title">{{stringFormat($t(`label.tier`), 2)}}</v-card-title>-->
    <!--                                <v-divider class="mx-3 primary"></v-divider>-->
    <!--                                <v-card-text>-->
    <!--                                    <v-row>-->
    <!--                                        <v-col cols=12>-->
    <!--                                             <label class="detail">{{stringFormat($t(`label.downlinesCommission`), getConfig(2))}}</label>-->
    <!--                                        </v-col>-->
    <!--                                    </v-row>-->
    <!--                                </v-card-text>-->
    <!--                            </v-card>-->
    <!--                        </v-col>-->
    <!--                    </v-row>-->
    <!--                </v-sheet>-->
    <!--            </v-carousel-item>-->
    <!--            <v-carousel-item>-->
    <!--                <v-sheet tile light>-->
    <!--                    <v-row no-gutters justify="center">-->
    <!--                        <v-col cols=8 sm=7>-->
    <!--                            <label>{{stringFormat($t(`label.totalTierMember`), 3)}}</label>-->
    <!--                            <v-card class="primary yellow&#45;&#45;text title text-center pa-1 mt-3"><v-icon class="yellow&#45;&#45;text">person</v-icon> : {{referralOverview.downline_lv3}}</v-card>-->
    <!--                            <v-card class="detail-card base mt-3 pt-2 px-1">-->
    <!--                                <v-card-title class="title">{{stringFormat($t(`label.tier`), 3)}}</v-card-title>-->
    <!--                                <v-divider class="mx-3 primary"></v-divider>-->
    <!--                                <v-card-text>-->
    <!--                                    <v-row>-->
    <!--                                        <v-col cols=12>-->
    <!--                                            <label class="detail">{{stringFormat($t(`label.downlinesCommission`), getConfig(3))}}</label>-->
    <!--                                        </v-col>-->
    <!--                                    </v-row>-->
    <!--                                </v-card-text>-->
    <!--                            </v-card>-->
    <!--                        </v-col>-->
    <!--                    </v-row>-->
    <!--                </v-sheet>-->
    <!--            </v-carousel-item>-->
    <!--        </v-carousel>-->
  </div>
</template>

<script>
import stringFormat from 'string-format'
import { ROUTE_NAME } from '@/constants/route.constants'
import { uiHelper, locale, errorCodeHelper, formValidator } from '@/util'
import { SHARED } from '@/constants/constants'
import deleteIcon from '@/assets/svg/delete-icon.svg'
import _ from 'lodash'
import { REFERRAL_GET_OVERVIEW, REFERRAL_GET_DOWNLINES, REFERRAL_GET_REPORT, REFERRAL_GET_CONFIG } from '@/store/referral.module'
export default {
  name: 'referralTier',
  components: {
    deleteIcon
  },
  data: () => ({
    referralCode: '',
    stringFormat: stringFormat,
    dateOfBirthMenu: false,
    language: uiHelper.getLanguage(),
    validator: formValidator,
    shared: SHARED,
    selectedTab: 'tier',
    dates: ['', ''],
    currentMobileSlide: 0,
    routeName: ROUTE_NAME,
    tierList: [
      {
        title: 'tier 1',
        percent: '0.7',
        currentTier: true,
        downlineCount: 0
      },
      {
        title: 'tier 2',
        percent: '0.2',
        downlineCount: 0
      },
      {
        title: 'tier 3',
        percent: '0.2',
        downlineCount: 0
      }
    ],
    overview: {},
    share_url: ''
  }),
  created() {
    this.getReferralConfig()
    this.getReferralOverview()
    this.getReferralDownlines()
    this.getReferralReport()
  },
  computed: {
    memberInfo() {
      return this.$store.state.member.info
    },
    totalDownlineCount() {
      let total = 0

      this.tierList.forEach(_tier => {
        total += _tier.downlineCount
      })

      return total
    },
    dateRangeText() {
      let date1 = this.dates[0] ? this.dates[0] : ''
      let date2 = this.dates[1] ? this.dates[1] : ''
      return date1 + ' - ' + date2
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    referralOverview() {
      return this.$store.state.referral.overview
    },
    referralConfig() {
      return this.$store.state.referral.config
    },
    webShareApiSupported() {
      return navigator.share
    }
  },
  watch: {
    isLoggedIn() {
      this.getReferralOverview()
    },
    referralOverview() {
      this.overview = this.$store.state.referral.overview

      this.share_url = uiHelper.getHostname() + '?refer_code=' + this.overview.my_referral_code

      this.tierList[0].downlineCount = this.overview.downline_lv1
      this.tierList[1].downlineCount = this.overview.downline_lv2
      this.tierList[2].downlineCount = this.overview.downline_lv3

      this.tierList[0].percent = this.getConfig(1)
      this.tierList[1].percent = this.getConfig(2)
      this.tierList[2].percent = this.getConfig(3)

      this.referralCode = this.overview.my_referral_code
    }
  },
  methods: {
    share() {
      const sharing = {
        title: 'Refer a friend now and earn commission',
        text: 'Your referral code is ' + this.overview.my_referral_code + '.Refer a friend now and earn commission now! ',
        url: this.share_url
      }

      if (this.webShareApiSupported) {
        navigator.share(sharing)
      } else {
        let $f = this
        this.$copyText(this.share_url).then(function(e) {
          $f.alertMessage = 'Referral Link Copied!'
          $f.alertSuccess = true
          $f.alertShow = true
          alert(locale.getMessage('message.refLinkCopied'))
        })
      }
    },
    goToRegisterPage() {
      this.$router.push({
        name: ROUTE_NAME.REGISTER
      })
    },
    goToLoginPage() {
      this.$router.push({
        name: ROUTE_NAME.LOGIN
      })
    },
    getConfig(index) {
      let config = this.referralConfig.find(c => c.level == index)
      if (config) {
        return config.percentage
      } else {
        return 0
      }
    },
    openMsgDialog(selectedMsg) {
      this.msgDialog = {
        show: true,
        msg: selectedMsg.message,
        title: selectedMsg.subject
      }
    },
    closeMsgDialog() {
      this.msgDialog = {
        show: false
      }
    },
    getReferralConfig() {
      this.$store.dispatch(`${REFERRAL_GET_CONFIG}`)
    },
    getReferralOverview() {
      if (this.isLoggedIn) this.$store.dispatch(`${REFERRAL_GET_OVERVIEW}`)
    },
    getReferralDownlines() {
      if (this.isLoggedIn) this.$store.dispatch(`${REFERRAL_GET_DOWNLINES}`)
    },
    getReferralReport() {
      if (this.isLoggedIn) this.$store.dispatch(`${REFERRAL_GET_REPORT}`)
    }
  }
}
</script>

<style lang="scss">
.referralCode-card {
  border-radius: 15px !important;
  border: 1px dashed #1d1d1d !important;
}

.share-card {
  background-color: #0066d1 !important;
  color: #ffffff !important;
  display: flex;
  align-items: center;
  justify-content: center;
  .theme--light.v-card {
    color: #ffffff;
  }
  border-radius: 15px !important;
}
.game-menu-image {
  background-color: #ffffff;
  -webkit-mask-image: var(--src);
  mask-image: var(--src);
  -webkit-mask-size: 100%;
  mask-size: 100%;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  width: 25px;
  height: 25px;
  margin-left: 8px;
}
.timeline-container {
  margin-right: 20px;
}

.v-timeline:before {
  bottom: 32px !important;
  height: 75% !important;
  top: 33px !important;
}
.tier-card.active-tier.v-card {
  background-color: var(--v-newMobilePrimary-base) !important;
  color: var(--v-newMobileSecondary-base) !important;
  .v-card__subtitle,
  .v-card__text {
    color: var(--v-newMobileSecondary-base) !important;
  }
}
.active-tier {
  .v-timeline-item__inner-dot {
    background-color: var(--v-newMobilePrimary-base) !important;
    color: var(--v-newMobileSecondary-base) !important;
  }
}
.tier-card {
  background-color: #d9d9d9;
  color: #000000;
}
.beforeLoginBtn {
  margin: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
}

.prelogin-panel {
  background-color: black;
  color: white;
  padding-bottom: 15px;
  border-radius: 10px;
  margin: 0px 0px;
}

.inpage-before-login-first {
  color: white;
  background-color: var(--v-newMobilePrimary-base);
  border: 1px solid #ddd;
  border-radius: 15px;
}

.inpage-navigator-before-login-second {
  color: black;
  background-color: var(--v-newMobileSecondary-base);
  border-radius: 15px;
}
.referral-tier {
  .title {
    font-size: 18px !important;
  }
  .detail-card {
    min-height: 240px;
    .detail {
      font: 16px;
    }
  }
  .mobile-carousel {
    height: 350px !important;
  }
}
@media (max-width: 959px) {
  .referral-tier {
    .v-timeline-item__dot {
      width: 35px;
    }
  }
}
</style>
